import React from 'react'
import ReactDOM from 'react-dom'

import Principal from './components/Principal'

ReactDOM.render(
    <Principal />,
    document.getElementById('root')
)